import { z } from 'zod';
import { lastKnownLocationSchema } from '../../common/last-known-location.schema';

/**
 * `Driver.meta` — agent-facing signal layer on the Driver document.
 *
 * Mirrors `User.meta.location.accurate` but scoped to a Driver so
 * the fleet god-view can read a Driver's last GPS point directly
 * without a User join. See `docs/ai/user-signals.md` for the
 * fan-out semantics — Driver writes only fire when the source
 * ping's user actually has the `driver` role.
 */
export const driverMetaSchema = z.object({
  /**
   * Last GPS-quality point for this Driver. Only writers with a
   * `source` of `app_foreground` / `app_background` / `iot_gps`
   * update this — approximate signals (IP / user-stated /
   * phone-country / saved-default) stay on `User.meta.location`.
   */
  lastKnownLocation: lastKnownLocationSchema.optional(),
});
export type DriverMeta = z.infer<typeof driverMetaSchema>;
